export default __webpack_public_path__ + "static/media/placeholder.2218d12f.svg";